// extracted by mini-css-extract-plugin
module.exports = {"root":"TalentTable_root__NGNx-","actions":"TalentTable_actions__3B1NL"};